import Bundle from "@framework/Bundle";

export const routes = require.context(
	"./",
	true,
	/.*\/@module($|\/routes\.(js))/
);

/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-START */
/* REMOVE-FOR-CLIENT-SSR-START */
export const controllers = [{value: () => import(/* webpackPreload: true */ "./@module/controller.js"), path: "./@module/controller.js"}];
export const models = [];
/* REMOVE-FOR-CLIENT-SSR-END */
export const libs = [];
export const styles = [];
export const constants = [];
export const loadable = require.context("./", true, /\.(loadable)\.(js)$/);
export const stores = [{value: () => import(/* webpackPreload: true */ "./@stores/AdminProfile.store.js"), path: "./@stores/AdminProfile.store.js"}, {value: () => import(/* webpackPreload: true */ "./Tables/ProviderQuotesTable/@stores/ProviderQuotesTable.store.js"), path: "./Tables/ProviderQuotesTable/@stores/ProviderQuotesTable.store.js"}, {value: () => import(/* webpackPreload: true */ "./Tables/ProviderReviewsTable/@stores/ProviderReviewsTable.store.js"), path: "./Tables/ProviderReviewsTable/@stores/ProviderReviewsTable.store.js"}];
export const extensions = [];
export const background = require.context("./", true, /\.(background)\.(js)$/);
/* webpack-strip-block:removed */
/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-END */
